<template>
    <header>
        <x-container fluid py-0>
            <x-layout align-center>
                <x-flex class="grow-0 mr-4">
                    <x-btn @click="toggleMenu" flat icon class="menu-activator">
                        <div class="menu-icon" :class="{ open: menuOpen }"/>
                    </x-btn>
                </x-flex>

                <x-flex>
                    <router-link :to="dashboardLink" class="logo" :class="{ hide: hideLogo }">
                        <span>TepfinX</span>

                        <img src="/assets/img/from-howden.svg">
                    </router-link>
                </x-flex>
            </x-layout>
        </x-container>
        <navigation-overlay :menuOpen="menuOpen" @closeNav="closeNav" />
    </header>
</template>

<script>
    import CircleIcon from '~/components/Shared/UIComponents/CircleIcon';
    import NavigationOverlay from '~/components/Shared/Partials/NavigationOverlay.vue';
    import NotificationsMixin from '~/mixins/notifications';

    export default {
        name: 'NavBar',
        components: {
            CircleIcon,
            NavigationOverlay
        },
        mixins: [NotificationsMixin],
        props: ['info', 'notifications'],
        data: function () {
            return {
                user: [],
                menuOpen: false,
                hideLogo: false
            }
        },
        computed: {
            dashboardLink() {
                return this.$root.user.company && this.$root.user.company.company_type === 'insurer' ? '/insurer/dashboard/' : '/agent/dashboard/';
            },
            showBackButton() {
                return !['broker-dashboard', 'insurer-dashboard'].includes(this.$route.name);
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            toggleMenu() {
                this.menuOpen = !this.menuOpen;
            },
            closeNav() {
                this.menuOpen = false;
            },
            handleScroll(event) {
                this.hideLogo = window.scrollY > 0;
            }
        }
    }
</script>

<style lang="scss" scoped>

    header {
        position: sticky;
        top: 0;
        line-height: 1;
        z-index: 199;

        .layout {
            height: $header-height;
        }

        .logo {
            font-size: rem(24px);
            font-weight: 600;
            line-height: 1em;
            text-decoration: none;
            color: $color-white;
            height: 24px;
            display: flex;
            align-items: flex-end;
            transition: opacity 0.3s ease;

            span {
                margin-right: 12px;
            }

            img {
                height: 8px;
                margin-bottom: 3px;
            }

            &.hide {
                opacity: 0;
                pointer-events: none;
            }
        }

        .menu-activator {
            cursor: pointer;

            .menu-icon {
                position: relative;
                width: 26px;
                height: 13px;
                z-index: 5;

                &:before,
                &:after {
                    content: '';
                    position: absolute;
                    left: 50%;
                    width: 100%;
                    height: 4px;
                    background: $color-white;
                    @include transform(translateX(-50%));
                    @include transition(transform 0.2s, top 0.2s 0.1s, bottom 0.2s 0.1s);
                }

                &:before {
                    top: 0;
                }

                &:after {
                    bottom: 0;
                }

                &.open {
                    &:before,
                    &:after {
                        @include transition(top 0.2s, bottom 0.2s, transform 0.2s 0.1s);
                    }

                    &:before {
                        top: 4px;
                        @include transform(translateX(-50%) rotate(45deg));
                    }

                    &:after {
                        bottom: 5px;
                        @include transform(translateX(-50%) rotate(-45deg));
                    }
                }
            }
        }

        .back-button {
            height: 28px;
            background: transparent;
            color: inherit;
            font-weight: 600;
            font-size: rem(12px);
            text-transform: uppercase;
            letter-spacing: rem(1px);

            :deep(.x-tag__content) {
                height: 28px;
                padding: 0 10px;
                cursor: pointer;
            }

            .x-avatar {
                margin-right: rem(-6px);

                .x-icon {
                    transition: none !important;
                }
            }

            &:hover {
                background: $color-body-text;
                color: $color-black;
            }
        }
    }

    .user-menu-content {
        overflow: visible;
        contain: layout;
        max-width: 450px;

        &:after {
            content: '';
            position: absolute;
            right: 18px;
            top: -6px;
            @include transform(rotate(-45deg));
            border: 6px solid $color-grey-9;
            border-top-right-radius: $border-radius;
        }
    }

</style>
